import { BiSolidPhoneCall } from "react-icons/bi";
import { IoMdMail, IoMdAlarm, IoMdHelpCircle } from "react-icons/io";
import { FaRegSmile } from "react-icons/fa";
import { SiYoutubemusic } from "react-icons/si";

export const DocUpload = [
  {
    id: Math.random() * 10,
    name: "Doc_1",
    label: " Image 1",
  },
  {
    id: Math.random() * 10,
    name: "Doc_2",
    label: " Image 2",
  },
  {
    id: Math.random() * 10,
    name: "Doc_3",
    label: " Image 3",
  },
  {
    id: Math.random() * 10,
    name: "Doc_4",
    label: " Image 4",
  },
];
let browserName = "Unknown Browser";
let IP = "";
// const getLicensInfo = async () => {
//   let info = await GetUserInfo();
//   const userAgent = navigator.userAgent;
//   fetch("https://api.ipify.org?format=json")
//     .then((response) => response.json())
//     .then((data) => {
//       IP = data.ip;
//     })
//     .catch((error) => {
//       console.error("Error fetching IP: ", error);
//     });
//   // Detect browser name

//   if (userAgent.indexOf("Opera") !== -1 || userAgent.indexOf("OPR") !== -1) {
//     browserName = "Opera";
//   } else if (userAgent.indexOf("Edge") !== -1) {
//     browserName = "Microsoft Edge";
//   } else if (userAgent.indexOf("Chrome") !== -1) {
//     browserName = "Google Chrome";
//   } else if (userAgent.indexOf("Safari") !== -1) {
//     browserName = "Apple Safari";
//   } else if (userAgent.indexOf("Firefox") !== -1) {
//     browserName = "Mozilla Firefox";
//   } else if (
//     userAgent.indexOf("MSIE") !== -1 ||
//     userAgent.indexOf("Trident") !== -1
//   ) {
//     // Trident is for IE11
//     browserName = "Microsoft Internet Explorer";
//   }

//   return info;
// };
// export const LicenseInfo = [
//   {
//     title: "Company Name",
//     value:
//       getLicensInfo()?.userDetails &&
//       getLicensInfo()?.userDetails[0]?.CompanyCode.CompanyName,
//   },
//   {
//     title: "Branch Name",
//     value:
//       getLicensInfo()?.userDetails &&
//       getLicensInfo()?.userDetails[0]?.Default_Branch,
//   },
//   {
//     title: "Company Code",
//     value:
//       getLicensInfo()?.userDetails &&
//       getLicensInfo()?.userDetails[0]?.CompanyCode?.CompanyCode,
//   },
//   {
//     title: "Username",
//     value:
//       getLicensInfo()?.userDetails && getLicensInfo()?.userDetails[0].UserName,
//   },
//   { title: "Customer Id", value: "35419" },
//   { title: "Sales Id", value: "2622" },
//   { title: "Browser", value: browserName },
//   { title: "IP Address", value: IP },
//   {
//     title: "License Issued to",
//     value:
//       getLicensInfo()?.userDetails &&
//       getLicensInfo()?.userDetails[0]?.CompanyCode.CompanyName,
//   },
//   {
//     title: "License Mobile No",
//     value:
//       getLicensInfo()?.userDetails && getLicensInfo()?.userDetails[0]?.Mobile,
//   },
//   {
//     title: "Database Backup Email Id",
//     value: "orionexpresslogistics@gmail.com",
//   },
//   { title: "License GSTNO", value: "27AADCO1183G1ZJ" },
// ];
export const LicenseInfo = [
  {
    title: "Company Name",
    value: "",
  },
  {
    title: "Branch Name",
    value: "",
  },
  {
    title: "Company Code",
    value: "",
  },
  {
    title: "Username",
    value: "",
  },
  { title: "Customer Id", value: "35419" },
  { title: "Sales Id", value: "2622" },
  { title: "Browser", value: browserName },
  { title: "IP Address", value: IP },
  {
    title: "License Issued to",
    value: "",
  },
  {
    title: "License Mobile No",
    value: "",
  },
  {
    title: "Database Backup Email Id",
    value: "orionexpresslogistics@gmail.com",
  },
  { title: "License GSTNO", value: "27AADCO1183G1ZJ" },
];
export const FooterInfo = [
  {
    icon: <BiSolidPhoneCall />,
    title: "Contact Us On",
    value: "+3458634566, +7534576576345, +3456566537458",
  },
  {
    icon: <IoMdMail />,
    title: "Email Support",
    value: "service@headtler.com",
  },
  {
    icon: <IoMdAlarm />,
    title: "Working Days",
    value: "Mon-Sat(10 AM to 7 PM)",
  },
];

export const FooterInfo2 = [
  {
    icon: <IoMdHelpCircle />,
    title: "Help",
  },
  {
    icon: <FaRegSmile />,
    title: "Feedback",
  },
  {
    icon: <SiYoutubemusic />,
    title: "Tutorial",
  },
];


export const SupportInputs = [
  {
    name: "Salary_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Name",
        label: "Name",
        type: "text",
        FirstCharCap: true,
        isRequired: true,
        // autoFocus: true,
      },
      {
        id: Math.random() * 10,
        name: "Mobile_No",
        label: "Mobile No",
        type: "number",
      },
      {
        id: Math.random() * 10,
        name: "Issue_Related_To",
        label: "Issue Related To",
        type: "Dropdown",
        dropdowndata: [
          "GST Related",
          "Printing Related",
          "Sales Inquiry",
          "Accounting Effect Isssue",
          "New Development",
          "ERROR/Other",
        ]
      },
      {
        id: Math.random() * 10,
        name: "Issue_Subject",
        label: "Issue Subject",
        type: "text",
      },
      {
        id: Math.random() * 10,
        name: "Issue_Details",
        label: "Issue Details",
        type: "textarea",
      },
    ]
  },

]
